import { Spin } from 'antd';
import * as React from 'react';
import { Suspense } from 'react';

import { ViewerAppryze, ViewerAppryzeProps } from './viewer-appryze';

export const ViewerAppryzeSimple: React.FC<ViewerAppryzeProps> = ({ height = '186px', ...restProps }) => {
    return (
        <Suspense
            fallback={
                <Spin spinning={true}>
                    <div style={{ height }}></div>
                </Spin>
            }
        >
            <ViewerAppryze height={height} {...restProps} />
        </Suspense>
    );
};
